export class ProductServicePricingPlan {
	productServiceName: string;
	startDate: string;
	endDate: string;
	currency: string;
	billingMethod: string;
	invoicingMethod: string;
	paymentType: string;
	amount: string;
}
